import { isEmpty } from 'ramda';

import { KEYS } from 'components/evieOnboarding/utils/constants';

const UTM_PARAMS = ['utm_source', 'utm_campaign', 'utm_content'];

export const captureFirstTouchUtm = (search = window.location.search) => {
  try {
    if (window.localStorage.getItem(KEYS.FIRST_TOUCH_UTM)) return;

    const params = new URLSearchParams(search);
    const utm = UTM_PARAMS.reduce((acc, key) => {
      const value = params.get(key);
      return value ? { ...acc, [key]: value } : acc;
    }, {});

    if (isEmpty(utm)) return;

    window.localStorage.setItem(KEYS.FIRST_TOUCH_UTM, JSON.stringify(utm));
  } catch (error) {
    console.error(error);
  }
};

export const getFirstTouchUtm = () => {
  try {
    const stored = window.localStorage.getItem(KEYS.FIRST_TOUCH_UTM);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
